import React from "react";
import { Link, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";

import {
    Table,
    TableContainer,
    TableBody,
    TableHead,
    TableRow,
    Stack,
    Tooltip,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import RenderDate from "../../../Common/Date/RenderDate";
import PDPStatusIcon from "./PDPStatusIcon";
import LinkIcon from "@mui/icons-material/Link";
import RenderAppraiser from "./RenderAppraiser";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: 12,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const LinkBuilder = ({ text, id, appraisee }) => {
    const location = useLocation();
    const refererPath = encodeURIComponent(location.pathname);

    let display = text;
    const appraiseeUUID = appraisee?.uuid ?? null;

    if (id && appraiseeUUID) {
        display = (
            <Link to={`/portfolio/pdps/${Number(id)}/?rp=${refererPath}`}>
                {text}
            </Link>
        );
    }

    return display;
};

function PDPTable({
    items,
    canUpdate,
    canAdd,
    canEdit,
    appraisalId,
    appraisee = null,
}) {
    return (
        <>
            <TableContainer>
                <Table sx={{ minWidth: 600 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Development plan</StyledTableCell>
                            <StyledTableCell>Appraiser</StyledTableCell>
                            <StyledTableCell align="center">
                                Start
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                End
                            </StyledTableCell>
                            <StyledTableCell align="right">
                                Progress&nbsp;
                            </StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(items) &&
                            items
                                .sort(
                                    (a, b) =>
                                        (b?.dateStart || 0) -
                                        (a?.dateStart || 0)
                                )
                                .map((row) => (
                                    <StyledTableRow key={row?.id}>
                                        <StyledTableCell>
                                            <LinkBuilder
                                                text={row?.title}
                                                id={row?.id}
                                                appraisee={appraisee}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <RenderAppraiser
                                                appraiser={row?.appraiser}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <RenderDate
                                                date={row?.dateStart}
                                                colourise={
                                                    !row?.status === "completed"
                                                }
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {row?.status === "completed" ? (
                                                <RenderDate
                                                    date={row?.dateEnd}
                                                />
                                            ) : (
                                                "-"
                                            )}
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                            <Stack
                                                direction="row"
                                                justifyContent="flex-end"
                                                spacing={2}
                                            >
                                                {row?.appraisalId > 0 && (
                                                    <Tooltip
                                                        title="Linked"
                                                        placement="top"
                                                        arrow
                                                    >
                                                        <LinkIcon color="disabled" />
                                                    </Tooltip>
                                                )}
                                                <PDPStatusIcon
                                                    status={row?.status}
                                                />
                                            </Stack>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                        <StyledTableRow key="totals">
                            <StyledTableCell
                                component="th"
                                scope="row"
                                sx={{ backgroundColor: "#FFFFFF" }}
                                colSpan={5}
                            ></StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
export default PDPTable;
